export default __webpack_public_path__ + "static/media/car4.65f27669.png";